import createHeadingId from "./createHeadingId";

export default createHeadingId;
